var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.swiperBannerList && _vm.swiperBannerList.length)?_c('SwipeBanner',{attrs:{"banner-list":_vm.swiperBannerList,"autoplay":_vm.autoplay},on:{"indicator-change":_vm.onBannerChange,"click-item":_vm.goBannerUrl}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }